import * as React from "react";
const Filter = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M4.22 5.861a1 1 0 01.764-1.645h14.032a1 1 0 01.764 1.645l-5.661 6.694v6.42a1 1 0 01-1.447.895l-2.238-1.119a1 1 0 01-.553-.894v-5.302l-5.66-6.694zm14.796-.645H4.984l5.66 6.694a1 1 0 01.237.645v5.302l2.238 1.118v-6.42a1 1 0 01.236-.645l5.661-6.694z" }));
Filter.displayName = "Filter";
var Filter_default = Filter;
export {
  Filter_default as default
};
